export default {
    state: {
        all: [],
        filtered: [],
        selectedProposalId: null,
        selectedProposalExpenseId: null,
        errors: {}
    },
	actions: {
		async createProposal({ state }, data) {
			state.errors = {};
			
            if (data.ti_required_psf == null) {
                state.errors = {
                    'ti_required_psf': ['TI Required PSF must be an integer.']
                }

                throw new Error('TI Required PSF must be an integer.');
            }

            if (data.ti_offered_psf == null) {
                state.errors = {
                    'ti_offered_psf': ['TI Offered PSF must be an integer.']
                }

                throw new Error('TI Offered PSF must be an integer.');
            }

            data.ti_required_psf = Number.prototype.cleanseFloat(data.ti_required_psf) * 100;
            data.ti_offered_psf = Number.prototype.cleanseFloat(data.ti_offered_psf) * 100;

            try {
                const response = await axios.post('/proposals', data);
                
                // Add the new proposal to state
                if (response.data.proposal) {
                    state.all.push(response.data.proposal);
                    state.filtered.push(response.data.proposal);
                }
                
                return response.data.proposal;
            } catch (error) {
                state.errors = error.response?.data?.errors || {};
                console.log(error);
                throw error;
            }
		},

		async saveProposal({ state }) {
			state.errors = {};

			let proposal = _.cloneDeep(this.getters.selectedProposal);

            proposal.ti_required_psf = Number.prototype.cleanseFloat(this.getters.selectedProposal.ti_required_psf) * 100;
            proposal.ti_offered_psf = Number.prototype.cleanseFloat(this.getters.selectedProposal.ti_offered_psf) * 100;
            proposal._method = "PATCH";

            await axios.post(`/proposals/${this.getters.selectedProposal.id}`, proposal).then(response => {
            	console.log(response);
            }).catch(error => {
                console.log(error);

                state.errors = error.response.data.errors;
            });
		},

		async createProposalExpense({ state }, data) {
			state.errors = {};

            data.amount = Number.prototype.cleanseFloat(data.amount_in_dollars) * 100;

            await axios.post('/expenses', data).then(response => {
            	response.data.expense.cost_by_term_year = JSON.parse(response.data.expense.cost_by_term_year);
            	
				this.getters.selectedProposal.expenses.push(response.data.expense);
            }).catch(error => {
                console.log(error);
                state.errors = error.response?.data?.errors || {};
            });
		},

		async saveExpense({ state, dispatch }) {
			state.errors = {};

            this.getters.selectedProposalExpense.amount = Number.prototype.cleanseFloat(this.getters.selectedProposalExpense.amount_in_dollars) * 100;
            this.getters.selectedProposalExpense._method = "PATCH";

            await axios.post(`/expenses/${this.getters.selectedProposalExpense.id}`, this.getters.selectedProposalExpense).then(response => {
                let expenseData = response.data.expense;
                expenseData.cost_by_term_year = JSON.parse(expenseData.cost_by_term_year);

                this.getters.selectedProposal.expenses = _.remove(this.getters.selectedProposal.expenses, expense => expense.id != expenseData.id);
                this.getters.selectedProposal.expenses.push(expenseData);
            }).catch(error => {
                console.log(error);

                state.errors = error.response.data.errors;
            });
		},

        async deleteExpense({ state, dispatch }, expenseId) {
            await axios.delete('/expenses/' + expenseId)
                .then((response) => {
                    dispatch('removeExpense', expenseId);
                })
                .catch((error) => {
                    console.log(error);
                }
            );
        },

        removeExpense({ state }, expenseId) {
            this.getters.selectedProposal.expenses = _.remove(this.getters.selectedProposal.expenses, (expense) => { return expense.id != expenseId });
        },

		saveExpenseEscalations({ state, dispatch }) {
			return;
		},

        async createRevision({ state }) {
            await axios.post(`/proposal/${state.selectedProposalId}/createRevision`).then(response => {
                console.log(response);
                
                response.data.proposal.expenses = _.map(response.data.proposal.expenses, expense => {
                    expense.cost_by_term_year = JSON.parse(expense.cost_by_term_year);

                    return expense;
                });

                state.all.push(response.data.proposal);
                state.filtered.push(response.data.proposal);                
                state.selectedProposalId = response.data.proposal.id;

                window.history.pushState(response.data.proposal, "Proposal", response.data.proposal.view_url);
            }).catch(error => {
                console.log(error);

                state.errors = error.response.data.errors;
            });
        },

        async deleteProposal({ state, dispatch }) {
            await axios.delete('/proposals/' + state.selectedProposalId)
                .then((response) => {
                    console.log(response);
                })
                .catch((error) => {
                    console.log(error);
                }
            );
        },
	},
	mutations: {

	},
	getters: {
        selectedProposal: (state) => {
            return _.find(state.all, ['id', state.selectedProposalId]);
        },

        selectedProposalExpense: (state, getters) => {
            return _.find(getters.selectedProposal.expenses, ['id', state.selectedProposalExpenseId]);
        }
	}
};